import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { throwError } from 'rxjs';




import { HttpClientService } from 'lib/ng2-sapmp/src/providers';

@Injectable()
export class UserSummaryService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService) { }

  getUserInfo(getUserDetailsservice) {
    return this.httpClientService.get(getUserDetailsservice)
      .pipe(
       map((user: HttpResponse<any>) => user)
      ,catchError( this.handleError ));
  }

  getProductInfo(getProductDetailsservice) {
    return this.httpClientService.get(getProductDetailsservice)
      .pipe(
       map((user: HttpResponse<any>) => user)
      ,catchError( this.handleError ));
  }

   handleError = (error) => {
    return throwError(error);
  }

}

